// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 1520) return "static/chunks/1520-88b00d83b1b11047.js";
	if (chunkId === 7940) return "static/chunks/7940-3cbfff759432be8f.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3124":"34fc603e1205339a","9256":"dd63b10ae613cc73"}[chunkId] + ".js";
};